module.exports = __webpack_public_path__ + "naghmeh-social-icon--facebook.svg?cb5d7d68774e5761c71f0a3381e3bb93";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-icons-edited/naghmeh-social-icon--facebook.svg
// module id = 18
// module chunks = 0